import { TableCell, TableRow } from "@mui/material";
import { memo } from "react";
import { dateFormatConversion } from "Utils/Common/viewRequisitiontabs";

const Row = ({ RowData, tabsInfo, isChecked, onCheckChange }: any) => {
  const isColumnVisible = (col: any) =>
    col?.isShowOnUi && col?.isShow && !col?.isExpandData;

  return (
    <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
      <TableCell style={{ width: "49px" }}>
        <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isChecked}
            onChange={(e) => onCheckChange(e.target.checked, RowData)}
          />
        </label>
      </TableCell>
      {tabsInfo &&
        tabsInfo.map((tabData: any) =>
          isColumnVisible(tabData) ? (
            <TableCell
              key={tabData.columnKey}
              id={`CreateBatch_${tabData?.columnKey}_${RowData?.RequisitionOrderID}`}
            >
              {tabData.columnKey === "RequisitionStatus" ? (
                <span
                  style={{
                    backgroundColor: "#FFA800",
                    color: "#fff",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  {RowData?.[tabData?.columnKey] ?? "-"}
                </span>
              ) : (
                (dateFormatConversion(RowData, tabData?.columnKey) ??
                RowData?.[tabData?.columnKey] ??
                "-")
              )}
            </TableCell>
          ) : null
        )}
    </TableRow>
  );
};

export default memo(Row);
